




















import { Component, Vue } from 'vue-property-decorator';

import ENV from '@/environment';

@Component({})
export default class Home extends Vue {

  content = {};
  env = ENV;

  mounted() {
    if (this.env.REGION === 'by') {
      this.content = this.contentBy;
    } else {
      this.content = this.contentRu;
    }
  }

  contentRu = {
    title: 'проездной',
    description: 'Больше не нужно искать самый выгодный Делимобиль на карте. С Проездным все доступные в тарифе автомобили стоят одинаково и днем, и ночью.',
  };
  contentBy = {
    title: 'проездной',
    description: 'Проездной – самый лучший вариант, если пользуетесь машиной регулярно. <br>Выбираете количество минут в движении и ожидании. А минуты можно использовать на разных машинах и до 30 дней.',
  };
}
